import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  body:has(&) {\n    .ant-input-affix-wrapper-focused {\n      border-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        ""
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useViewModel } from "@/lib/viewModels";
import { RNumberViewModel } from "./RNumberViewModel";
import styled from "styled-components";
import { observer } from "mobx-react-lite";
import { FormWrapper, Wrapper } from "@/modules/landings/protection/components/TrackingNumber";
import { TrackingResult } from "@/modules/landings/protection/components/TrackingResult";
import React from "react";
import { TrackingNumberForm } from "@/modules/landings/protection/components/TrackingNumberForm";
import { themeGet } from "@styled-system/theme-get";
import { useApiService } from "@/lib/apiService";
export const TrackingNumberFormViewWrapper = styled.div.withConfig({
    componentId: "sc-17556ec6-0"
})(_templateObject(), themeGet("primary.0", "#002FA8"));
const RNumberViewWrapper = styled.div.withConfig({
    componentId: "sc-17556ec6-1"
})(_templateObject1());
export const RNumberView = observer((props)=>{
    const apiService = useApiService();
    const { status , actions  } = useViewModel({
        apiService
    }, RNumberViewModel);
    ;
    return /*#__PURE__*/ _jsxs(RNumberViewWrapper, {
        children: [
            /*#__PURE__*/ _jsxs(Wrapper, {
                children: [
                    /*#__PURE__*/ _jsxs("p", {
                        className: "title",
                        children: [
                            "R인증 번호를 조회하여",
                            /*#__PURE__*/ _jsx("br", {}),
                            "정당한 저작권 이용 여부를 확인하세요."
                        ]
                    }),
                    /*#__PURE__*/ _jsx(FormWrapper, {
                        children: /*#__PURE__*/ _jsx(TrackingNumberFormViewWrapper, {
                            children: /*#__PURE__*/ _jsx(TrackingNumberForm, {
                                title: "R인증 번호 조회",
                                name: "TrackingNumberForm",
                                initialStatus: status.initialStatus,
                                initialValues: status.initialValues,
                                onSubmit: actions.onSubmit
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(TrackingResult, {
                data: status.RNumberResult
            })
        ]
    });
});
